import { AUTH_VALIDATION_MESSAGES } from "../constants/authentication.constants";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^[6-9]\d{9}$/;
const OTP_PATTERN = /^\d{6}$/;

/**
 * Single source of truth for authentication field validation rules
 * (email, password, name, phone, OTP), shared by all auth forms.
 */
export const validators = {
    email: (value) =>
        EMAIL_PATTERN.test(value) ? null : AUTH_VALIDATION_MESSAGES.INVALID_EMAIL,

    password: (value) =>
        value.length >= 8 ? null : AUTH_VALIDATION_MESSAGES.INVALID_PASSWORD,

    name: (value) =>
        value.trim().length >= 2 ? null : AUTH_VALIDATION_MESSAGES.INVALID_NAME,

    phone: (value) =>
        PHONE_PATTERN.test(value) ? null : AUTH_VALIDATION_MESSAGES.INVALID_PHONE,

    otp: (value) =>
        OTP_PATTERN.test(value) ? null : AUTH_VALIDATION_MESSAGES.INVALID_OTP,
};

/**
 * Runs a map of { fieldName: value } through their validators.
 * Returns an errors object { fieldName: errorMessage | null }.
 */
export function validateFields(fields) {
    return Object.entries(fields).reduce((acc, [key, value]) => {
        acc[key] = validators[key] ? validators[key](value) : null;
        return acc;
    }, {});
}

export const isValid = (errors) => Object.values(errors).every((e) => e === null);
